import type { ActionDefinition, ActionNodeData, AutomationSubjectType } from "../../types"

export function resolveActionProvidedSubjects(
  definition: Pick<ActionDefinition, "providesSubjects" | "providesSubjectsByFields" | "fields">,
  fields?: ActionNodeData["fields"]
): AutomationSubjectType[] {
  const subjects = new Set(definition.providesSubjects ?? [])

  for (const rule of definition.providesSubjectsByFields ?? []) {
    const selectedValue =
      fields?.[rule.field] ?? definition.fields.find((field) => field.key === rule.field)?.defaultValue
    if (typeof selectedValue !== "string") continue

    for (const subject of rule.values[selectedValue] ?? []) subjects.add(subject)
  }

  return [...subjects]
}
